import {
    faArrowDown,
    faArrowUp,
    faPhone,
    faSave,
    faTrash,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useForm, FormProvider } from "react-hook-form";
import {
    IClienteCompleto,
    ITelefonesCliente,
} from "../../../../../../Interfaces/Geral/Cliente/IClienteSimples";
import InformacoesEnderecoCard from "../../../InformacoesEndereco";
import { AtualizarClienteController } from "../../../../../../Controllers/Geral/GestaoClientes/GestaoClientesController";
import { ChangeEvent, useState } from "react";
import { useClientePage } from "../../../../../../Context/ClientePage";
import { useUserInfor } from "../../../../../../Context/User";
import { ListarPerfilTipoContaController } from "../../../../../../Controllers/Geral/CadastroEEditaTipoConta/CadastroEEditaTipoContaController";
import { ListarPerfilFinanceiroController } from "../../../../../../Controllers/Geral/GestaoDeCadastros/PerfilFinanceiro/PerfilFinanceiroController";
import useAsyncEffect from "../../../../../../hooks/useAsyncEffect";
import OrSpinner from "../../../../../Utils/OrSpinner";
import { Collapse, OverlayTrigger, Tab, Tabs, Tooltip } from "react-bootstrap";
import useAsyncCallback from "../../../../../../hooks/useAsyncCallback";
import { Spinner } from "../../../../../Loding/SpinnerPadrao";
import { useAtendimentoPage } from "../../../../../../Context/AtendimentoPage";
import { ListarTipoTelefoneController } from "../../../../../../Controllers/Geral/TipoTelefone/TipoTelefoneControllers";
import { ListarMotivoCompraController } from "../../../../../../Controllers/Geral/GestaoDeCadastros/MotivoCompra/MotivoCompraControllers";
import { ListarBancosController } from "../../../../../../Controllers/Geral/ListarBancosController/ListarBancosController";
import {
    ListarEstadosController,
    ListarProfissoesController,
} from "../../../../../../Controllers/Geral/CadastrarCliente/CadastrarClienteController";
import { ListarCanalAtendimentoContoller } from "../../../../../../Controllers/Geral/GestaoDeCadastros/TipoCanalAtendimento/TipoCanalAtendimentoController";
import UnForm from "../../../../../Form";
import { MoneyReaisFieldMask } from "../../../../../../Validations/InputMasks";
import { formatMoneyReais } from "../../../../../../Tools/FormatTools";
import { useHistoricoContext } from "../../../../../../Context/Historico";
import { IListProponentesResponse } from "../../../../../../Interfaces/Vendas/Proponentes/ProponentesInterface";
import Swal from "sweetalert2";
import CopyToClipboard from "../../../../../Utils/CopyToClipboard";
import Telefones from "./Telefones/Telefones";
// import { formatPhoneNumber } from "../../../../../../Tools/FormatTools";

interface IDadosCadastraisClienteProps {
    Cliente?: IClienteCompleto;
    GetCliente?: (...args: any[]) => Promise<IClienteCompleto | undefined>;
    ProponentesVendas?: (...args: any[]) => Promise<IListProponentesResponse[]>;
    setShow: React.Dispatch<React.SetStateAction<boolean>>;
}

interface IDadosCadastraisFormData extends IClienteCompleto {
    DS_NOME: string;
    DS_EMAIL: string;
    NR_CPF_CNPJ: string;
    NR_RG: number;
    DT_RG_EMISSAO: string;
    DS_SEXO: string;
    INFO_END: Array<{
        ID_CIDADE_ENDERECO?: number;
        ID_ESTADO_ENDERECO?: number;
        DS_BAIRRO_ENDERECO?: string;
        DS_LOGRADOURO_ENDERECO?: string;
        NR_ENDERECO_ENDERECO?: string;
        DS_COMPLEMENTO_ENDERECO?: string;
        NR_CEP_ENDERECO?: number;
    }>;
}

export default function EditarCliente(props: IDadosCadastraisClienteProps) {
    const formMethods = useForm<IDadosCadastraisFormData>();

    // const formMethodsTelefone = useForm<any>();

    const { OrgInfor } = useUserInfor();

    const { update } = useClientePage();

    const { ID_CASO, updateAtendimento, getInforVendas } = useAtendimentoPage();
    const { ReloadHistorico } = useHistoricoContext();

    const [mostrarUAU, setmostrarUAU] = useState(false);
    const [atualizarDadosUAU, setAtualizarDadosUAU] = useState(false);

    const [veiculoProprio, setVeiculoProprio] = useState("");

    const [listaTelefone, setListaTelefone] = useState<
        Array<ITelefonesCliente>
    >(props.Cliente?.LIST_TELEFONE || []);

    const [isFormVisible, setFormVisible] = useState(false);

    const [novoTelefone, setNovoTelefone] = useState<ITelefonesCliente>({
        ID_TIPO_TELEFONE: 0,
        NR_TELEFONE: "",
        DDD: "",
        DDI: "+55",
        RAMAL: 0,
        DS_OBSERVACAO: "",
        DS_TIPO_TELEFONE: "",
    });

    const [customDDI, setCustomDDI] = useState(novoTelefone.DDI);

    const handleAddPhone = () => {
        setNovoTelefone({
            ...novoTelefone,
            DDI: customDDI,
        });
        if (
            !novoTelefone.NR_TELEFONE ||
            !customDDI ||
            !novoTelefone.DDD ||
            !novoTelefone.ID_TIPO_TELEFONE
        ) {
            Swal.fire({
                icon: "error",
                text: "Preencha todos os campos obrigatórios para adicionar um telefone",
            });
            return;
        }
        setListaTelefone([...listaTelefone, novoTelefone]);
        setNovoTelefone({
            ID_TIPO_TELEFONE: 0,
            NR_TELEFONE: "",
            DDD: "",
            DDI: "+55",
            RAMAL: 0,
            DS_OBSERVACAO: "",
            DS_TIPO_TELEFONE: "",
        });
        setFormVisible(false);
    };

    const handleDeletePhone = (index: number) => {
        Swal.fire({
            title: "Deseja excluir esse telefone?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Sim, excluir!",
            cancelButtonText: "Cancelar",
        }).then((result) => {
            if (result.isConfirmed) {
                setListaTelefone(listaTelefone.filter((_, i) => i !== index));
            }
        });
    };

    const handleVeiculoProprioChange = (
        event: ChangeEvent<HTMLSelectElement>
    ) => {
        setVeiculoProprio(event.target.value);
    };

    const { value: lstCanalAtendimento, loading: lstCanalAtendimentoLoading } =
        useAsyncEffect(() => ListarCanalAtendimentoContoller(), []);

    // const [phone, setPhone] = useState<string>("");

    const { value: lstPerfilFinanceiro, loading: lstPerfilFinanceiroLoading } =
        useAsyncEffect(() => ListarPerfilFinanceiroController(), []);

    const { value: lstEstados, loading: lstEstadosLoading } = useAsyncEffect(
        () => ListarEstadosController(),
        []
    );

    const { value: lstPerfilTipoConta, loading: lstPerfilTipoContaLoading } =
        useAsyncEffect(() => ListarPerfilTipoContaController(), []);

    const { execute: AtualizarCliente, loading: AtualizarClienteLoading } =
        useAsyncCallback(AtualizarClienteController);

    const { value: lstProfissoes, loading: lstProfissoesLoading } =
        useAsyncEffect(() => ListarProfissoesController(), []);

    const { value: lstMotivoCompra, loading: lstMotivoCompraLoading } =
        useAsyncEffect(() => ListarMotivoCompraController(), []);

    const { value: lstTipoTelefone, loading: lstTipoTelefoneLoading } =
        useAsyncEffect(() => ListarTipoTelefoneController(), []);

    const { value: lstBancos, loading: lstBancosLoading } = useAsyncEffect(
        () => ListarBancosController(),
        []
    );

    function geradorMascaraFinanceira(inputName: keyof IClienteCompleto) {
        return (e: ChangeEvent<HTMLInputElement>) => {
            const mask = MoneyReaisFieldMask(e);

            formMethods.setValue(inputName, mask);
        };
    }

    // function handlePhoneChange(event: ChangeEvent<HTMLInputElement>) {
    //     const formattedPhone = formatPhoneNumber(event.target.value);
    //     setPhone(formattedPhone);
    // }

    const Cliente: IClienteCompleto | undefined =
        mostrarUAU && props.Cliente?.DADOS_CLIENTE
            ? {
                  NR_CPF: Number(props.Cliente?.DADOS_CLIENTE?.cpf_pes),
                  DS_NOME: props.Cliente?.DADOS_CLIENTE?.nome_pes,
                  DS_EMAIL: props.Cliente?.DADOS_CLIENTE?.email_pes,
                  DT_NASCIMENTO: props.Cliente?.DADOS_CLIENTE?.dtnasc_pes,
                  DS_ESTADO_CIVIL: props.Cliente?.DADOS_CLIENTE?.estciv_pf,
                  NR_ENDERECO_COBRANCA:
                      props.Cliente?.DADOS_CLIENTE?.EndCobranca?.numend_pend,
                  DS_ESTADO_COBRANCA:
                      props.Cliente?.DADOS_CLIENTE?.EndCobranca?.uf_pend,
                  DS_CIDADE_COBRANCA:
                      props.Cliente?.DADOS_CLIENTE?.EndCobranca?.cidade_pend,
                  DS_BAIRRO_COBRANCA:
                      props.Cliente?.DADOS_CLIENTE?.EndCobranca?.bairro_pend,
                  DS_LOGRADOURO_COBRANCA:
                      props.Cliente?.DADOS_CLIENTE?.EndCobranca?.endereco_pend,
                  DS_COMPLEMENTO_COBRANCA:
                      props.Cliente?.DADOS_CLIENTE?.EndCobranca
                          ?.complendereco_pend,
                  NR_ENDERECO_ENTREGA:
                      props.Cliente?.DADOS_CLIENTE?.EndEntrega?.numend_pend,
                  DS_ESTADO_ENTREGA:
                      props.Cliente?.DADOS_CLIENTE?.EndEntrega?.uf_pend,
                  DS_CIDADE_ENTREGA:
                      props.Cliente?.DADOS_CLIENTE?.EndEntrega?.cidade_pend,
                  DS_BAIRRO_ENTREGA:
                      props.Cliente?.DADOS_CLIENTE?.EndEntrega?.bairro_pend,
                  DS_LOGRADOURO_ENTREGA:
                      props.Cliente?.DADOS_CLIENTE?.EndEntrega?.endereco_pend,
                  DS_COMPLEMENTO_ENTREGA:
                      props.Cliente?.DADOS_CLIENTE?.EndEntrega
                          ?.complendereco_pend,
              }
            : props.Cliente;

    const [isPessoaFisica, setIsPessoaFisica] = useState(Cliente?.NR_CPF ?? "");

    function handleChange(e: ChangeEvent<HTMLInputElement>) {
        setmostrarUAU(e.target.checked);
    }

    function handleDadosCadastraisFormSubmit(
        formData: IDadosCadastraisFormData,
        closeModal: boolean
    ) {
        AtualizarCliente(
            {
                ...formData,
                ID_CHAVE_ERP: props.Cliente?.ID_CHAVE_ERP,
                ID_CONTA: props.Cliente?.ID_CONTA,
                NR_CPF: formData.NR_CPF_CNPJ || Cliente?.NR_CPF || "",
                DS_EMAIL: formData.DS_EMAIL || Cliente?.DS_EMAIL || "",
                ID_CIDADE_COBRANCA:
                    formData.INFO_END?.[0]?.ID_CIDADE_ENDERECO ??
                    Cliente?.ID_CIDADE_COBRANCA ??
                    0,
                DS_BAIRRO_COBRANCA:
                    formData.INFO_END?.[0]?.DS_BAIRRO_ENDERECO ||
                    Cliente?.DS_BAIRRO_COBRANCA ||
                    "",
                DS_COMPLEMENTO_COBRANCA:
                    formData.INFO_END?.[0]?.DS_COMPLEMENTO_ENDERECO ||
                    Cliente?.DS_COMPLEMENTO_COBRANCA ||
                    "",
                NR_ENDERECO_COBRANCA:
                    formData.INFO_END?.[0]?.NR_ENDERECO_ENDERECO ||
                    Cliente?.NR_ENDERECO_COBRANCA ||
                    "",
                DS_LOGRADOURO_COBRANCA:
                    formData.INFO_END?.[0]?.DS_LOGRADOURO_ENDERECO ||
                    Cliente?.DS_LOGRADOURO_COBRANCA ||
                    "",
                NR_CEP_COBRANCA:
                    formData.INFO_END?.[0]?.NR_CEP_ENDERECO ||
                    Cliente?.NR_CEP_COBRANCA ||
                    0,
                ID_CIDADE_ENTREGA:
                    formData.INFO_END?.[1]?.ID_CIDADE_ENDERECO ??
                    Cliente?.ID_CIDADE_ENTREGA ??
                    0,
                DS_BAIRRO_ENTREGA:
                    formData.INFO_END?.[1]?.DS_BAIRRO_ENDERECO ||
                    Cliente?.DS_BAIRRO_ENTREGA ||
                    "",
                DS_COMPLEMENTO_ENTREGA:
                    formData.INFO_END?.[1]?.DS_COMPLEMENTO_ENDERECO ||
                    Cliente?.DS_COMPLEMENTO_ENTREGA ||
                    "",
                NR_ENDERECO_ENTREGA:
                    formData.INFO_END?.[1]?.NR_ENDERECO_ENDERECO === "S/N"
                        ? "0"
                        : formData.INFO_END?.[1]?.NR_ENDERECO_ENDERECO
                        ? formData.INFO_END?.[1]?.NR_ENDERECO_ENDERECO
                        : Cliente?.NR_ENDERECO_ENTREGA || "0",
                DS_LOGRADOURO_ENTREGA:
                    formData.INFO_END?.[1]?.DS_LOGRADOURO_ENDERECO ||
                    Cliente?.DS_LOGRADOURO_ENTREGA ||
                    "",
                NR_CEP_ENTREGA:
                    formData.INFO_END?.[1]?.NR_CEP_ENDERECO ||
                    Cliente?.NR_CEP_ENTREGA ||
                    0,
                DS_NOME_PAI: formData.DS_NOME_PAI || Cliente?.DS_NOME_PAI || "",
                DS_NOME_MAE: formData.DS_NOME_MAE || Cliente?.DS_NOME_MAE || "",
                NR_DEPENDENTES:
                    formData.NR_DEPENDENTES || Cliente?.NR_DEPENDENTES || 0,
                DS_ESCOLARIDADE:
                    formData.DS_ESCOLARIDADE || Cliente?.DS_ESCOLARIDADE || "",
                NR_FILHOS: formData.NR_FILHOS || Cliente?.NR_FILHOS || 0,
                DS_IMOVEL_PROPRIO:
                    formData.DS_IMOVEL_PROPRIO ||
                    Cliente?.DS_IMOVEL_PROPRIO ||
                    "",
                DS_TEMPO_RESIDENCIA:
                    formData.DS_TEMPO_RESIDENCIA ||
                    Cliente?.DS_TEMPO_RESIDENCIA ||
                    "",
                DS_VEICULO_PROPRIO:
                    formData.DS_VEICULO_PROPRIO ||
                    Cliente?.DS_VEICULO_PROPRIO ||
                    "",
                DS_TIPO_VEICULO:
                    formData.DS_TIPO_VEICULO || Cliente?.DS_TIPO_VEICULO || "",
                DS_NATURALIDADE:
                    formData.DS_NATURALIDADE || Cliente?.DS_NATURALIDADE || "",

                DS_NACIONALIDADE:
                    formData.DS_NACIONALIDADE ||
                    Cliente?.DS_NACIONALIDADE ||
                    "",
                DS_SAUDACAO: formData.DS_SAUDACAO || Cliente?.DS_SAUDACAO || "",
                DS_ESTADO_CIVIL:
                    formData.DS_ESTADO_CIVIL || Cliente?.DS_ESTADO_CIVIL || "",
                ID_PROFISSAO_CONTA:
                    formData.ID_PROFISSAO_CONTA ||
                    Cliente?.ID_PROFISSAO_CONTA ||
                    0,
                DS_BAIRRO_OCUPACAO:
                    formData.DS_BAIRRO_OCUPACAO ||
                    Cliente?.DS_BAIRRO_OCUPACAO ||
                    "",
                DS_EMPRESA_EMPREGADORA:
                    formData.DS_EMPRESA_EMPREGADORA ||
                    Cliente?.DS_EMPRESA_EMPREGADORA ||
                    "",
                ID_MOTIVO_COMPRA:
                    formData.ID_MOTIVO_COMPRA || Cliente?.ID_MOTIVO_COMPRA || 0,
                ID_TIPO_CLIENTE:
                    formData.ID_TIPO_CLIENTE ||
                    Cliente?.tipoConta?.ID_PERFIL_TIPO_CONTA ||
                    0,
                ID_TIPO_CANAL_ATENDIMENTO:
                    formData.ID_TIPO_CANAL_ATENDIMENTO ||
                    Cliente?.ID_TIPO_CANAL_ATENDIMENTO ||
                    0,
                LIST_TELEFONE: listaTelefone
                    ? listaTelefone
                    : props.Cliente?.LIST_TELEFONE || [],
                DS_SEXO: formData.DS_SEXO || Cliente?.DS_SEXO || "",
                NR_RG: formData.NR_RG || Cliente?.NR_RG || 0,

                ID_BANCO: formData.ID_BANCO || Cliente?.ID_BANCO || 0,
                NR_CONTA_BANCO:
                    formData.NR_CONTA_BANCO || Cliente?.NR_CONTA_BANCO || 0,
                NR_AGENCIA_BANCO:
                    formData.NR_AGENCIA_BANCO || Cliente?.NR_AGENCIA_BANCO || 0,
                ID_PERFIL_FINANCEIRO_CONTA:
                    formData.ID_PERFIL_FINANCEIRO_CONTA ||
                    Cliente?.perfilFinanceiro?.ID_PERFIL_FINANCEIRO_CONTA ||
                    0,
                VL_RENDA: formData.VL_RENDA || Cliente?.VL_RENDA || 0,
                FL_RECEBER_COBRANCA:
                    Boolean(formData.FL_RECEBER_COBRANCA) ||
                    Boolean(Cliente?.FL_RECEBER_COBRANCA) ||
                    false,
            },
            atualizarDadosUAU
        ).then(() => {
            if (closeModal) {
                props.setShow(false);
            }
            if (ID_CASO) {
                getInforVendas?.();
                props.ProponentesVendas?.();
                updateAtendimento();
                ReloadHistorico();
                if (props.GetCliente) {
                    props.GetCliente?.();
                }
            } else {
                update();
            }
        });
    }

    const onSubmitSaveAndClose = (formData: IDadosCadastraisFormData) => {
        handleDadosCadastraisFormSubmit(formData, true);
    };

    const onSubmitSaveOnly = (formData: IDadosCadastraisFormData) => {
        handleDadosCadastraisFormSubmit(formData, false);
    };

    return (
        <OrSpinner
            loading={lstPerfilFinanceiroLoading || lstPerfilTipoContaLoading}
            spinner="capys"
        >
            <FormProvider {...formMethods}>
                <form onSubmit={formMethods.handleSubmit(onSubmitSaveOnly)}>
                    <Tabs
                        mountOnEnter
                        defaultActiveKey={"InformacoesCadastrais"}
                    >
                        <Tab
                            title={
                                <>
                                    <span className="nav-icon">
                                        <i className="fas fa-info "></i>
                                    </span>
                                    <span className="nav-text">
                                        Informações Cadastrais
                                    </span>
                                </>
                            }
                            eventKey="InformacoesCadastrais"
                        >
                            <OrSpinner
                                loading={lstEstadosLoading}
                                spinner="capys"
                            >
                                <div className="d-flex g-3">
                                    {props.Cliente?.DADOS_CLIENTE &&
                                        OrgInfor.COD_ERP_INTEGRACAO ===
                                            "UAU" && (
                                            <div className="d-flex text-success align-items-center mr-2">
                                                <label htmlFor="mostrardadosUAUcheckboxparaoeditar">
                                                    {" "}
                                                    Mostrar Dados UAU
                                                </label>
                                                <input
                                                    className="ml-2 mb-2 "
                                                    type={"checkbox"}
                                                    id={
                                                        "mostrardadosUAUcheckboxparaoeditar"
                                                    }
                                                    onChange={handleChange}
                                                    checked={mostrarUAU}
                                                />
                                            </div>
                                        )}

                                    {props.Cliente?.DADOS_CLIENTE &&
                                        OrgInfor.COD_ERP_INTEGRACAO ===
                                            "UAU" && (
                                            <div className="d-flex text-info align-items-center mr-2">
                                                <label htmlFor="atualizarDadosUAU">
                                                    {" "}
                                                    Atualizar Dados UAU
                                                </label>
                                                <input
                                                    className="ml-2 mb-2 "
                                                    type={"checkbox"}
                                                    id={"atualizarDadosUAU"}
                                                    onChange={(e) =>
                                                        setAtualizarDadosUAU(
                                                            e.target.checked
                                                        )
                                                    }
                                                    checked={atualizarDadosUAU}
                                                />
                                            </div>
                                        )}
                                </div>
                                <div className="form-group row pt-2 mb-3">
                                    <div className="col-lg-6">
                                        <label>Nome</label>
                                        <div className="input-icon">
                                            <input
                                                type="text"
                                                className="form-control"
                                                placeholder="Nome Cliente"
                                                name="DS_NOME"
                                                ref={formMethods.register({
                                                    required:
                                                        "Insira o nome do cliente",
                                                })}
                                                defaultValue={Cliente?.DS_NOME}
                                            />
                                            <span>
                                                <i className="flaticon2-sort-alphabetically icon-md"></i>
                                            </span>
                                        </div>
                                    </div>
                                    <div className="col-lg-6">
                                        {/* fazendo a verificação se é cliente terceiro e se é
                            do uau para desabilitar o campo de edição.
                            se não for só habilita o campo */}
                                        {Cliente?.DADOS_CLIENTE &&
                                        !Cliente.ID_CHAVE_ERP?.includes("CT") &&
                                        OrgInfor.COD_ERP_INTEGRACAO ===
                                            "UAU" ? (
                                            <OverlayTrigger
                                                overlay={
                                                    <Tooltip id="tooltip-disabled">
                                                        Para editar o email, o
                                                        campo "Atualizar Dados
                                                        UAU" deve estar marcado.
                                                    </Tooltip>
                                                }
                                                placement="top"
                                                trigger="hover"
                                            >
                                                {({
                                                    ref,
                                                    ...triggerHandler
                                                }) => (
                                                    <>
                                                        <label>Email</label>
                                                        <div
                                                            className="input-icon"
                                                            ref={ref}
                                                            {...triggerHandler}
                                                        >
                                                            <input
                                                                type="text"
                                                                className="form-control"
                                                                placeholder="Email"
                                                                name="DS_EMAIL"
                                                                ref={formMethods.register()}
                                                                defaultValue={
                                                                    Cliente?.DS_EMAIL
                                                                }
                                                                disabled={
                                                                    !atualizarDadosUAU
                                                                }
                                                            />
                                                            <span>
                                                                <i className="flaticon-multimedia icon-md"></i>
                                                            </span>
                                                        </div>
                                                    </>
                                                )}
                                            </OverlayTrigger>
                                        ) : (
                                            <>
                                                <label>Email</label>
                                                <div className="input-icon">
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        placeholder="Email"
                                                        name="DS_EMAIL"
                                                        ref={formMethods.register()}
                                                        defaultValue={
                                                            Cliente?.DS_EMAIL
                                                        }
                                                    />
                                                    <span>
                                                        <i className="flaticon-multimedia icon-md"></i>
                                                    </span>
                                                </div>
                                            </>
                                        )}
                                    </div>
                                </div>
                                {/* <div className="form-group row pt-2">
                                <div className="col-lg-4 mb-3">
                                    <label>Login Portal</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder="Login do portal"
                                        name="DS_LOGIN_PORTAL"
                                        ref={formMethods.register()}
                                        defaultValue={Cliente?.DS_LOGIN_PORTAL}
                                        disabled
                                    />
                                </div>
                            </div> */}
                                <div className="form-group row mb-3">
                                    <div className="col-lg-3 mb-3">
                                        <label>CPF / CNPJ</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            placeholder="CPF | CNPJ"
                                            name="NR_CPF_CNPJ"
                                            ref={formMethods.register()}
                                            defaultValue={Cliente?.NR_CPF}
                                            onChange={(e) => {
                                                setIsPessoaFisica(
                                                    e.target.value
                                                );
                                            }}
                                        />
                                    </div>

                                    {isPessoaFisica.toString().length <= 11 && (
                                        <>
                                            <div className="col-lg-3 mb-3">
                                                <label>Sexo</label>
                                                <select
                                                    className="form-control"
                                                    name="DS_SEXO"
                                                    defaultValue={
                                                        Cliente?.DS_SEXO
                                                    }
                                                    ref={formMethods.register()}
                                                >
                                                    <option></option>
                                                    <option>Masculino</option>
                                                    <option>Feminino</option>
                                                    <option>Outro</option>
                                                </select>
                                            </div>
                                            <div className="col-lg-3 mb-3">
                                                <label>RG</label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    placeholder="Nº RG"
                                                    name="NR_RG"
                                                    ref={formMethods.register()}
                                                    defaultValue={
                                                        Cliente?.NR_RG
                                                    }
                                                />
                                            </div>
                                            <div className="col-lg-3 mb-3">
                                                <label>UF Emissor RG</label>
                                                <select
                                                    className="form-control"
                                                    name="DS_RG_UF_EMISSOR"
                                                    ref={formMethods.register()}
                                                    defaultValue={
                                                        Cliente?.DS_RG_UF_EMISSOR
                                                    }
                                                >
                                                    <option></option>
                                                    {lstEstados?.map(
                                                        (estado) => (
                                                            <option
                                                                value={
                                                                    estado.DS_SIGLA
                                                                }
                                                            >
                                                                {
                                                                    estado.DS_ESTADO
                                                                }
                                                            </option>
                                                        )
                                                    )}
                                                </select>
                                            </div>
                                            <div className="col-lg-3">
                                                <label>Orgão Emissor RG</label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    name="DS_RG_ORGAO_EMISSOR"
                                                    ref={formMethods.register()}
                                                    defaultValue={
                                                        Cliente?.DS_RG_ORGAO_EMISSOR
                                                    }
                                                />
                                            </div>
                                            <div className="col-lg-3">
                                                <label>Data de Emissão</label>
                                                <input
                                                    type="date"
                                                    className="form-control"
                                                    placeholder="Data Emissão RG"
                                                    name="DT_RG_EMISSAO"
                                                    ref={formMethods.register()}
                                                    defaultValue={
                                                        Cliente?.DT_RG_EMISSAO
                                                            ? Cliente.DT_RG_EMISSAO.slice(
                                                                  0,
                                                                  10
                                                              )
                                                            : ""
                                                    }
                                                />
                                            </div>
                                            <div className="col-lg-3">
                                                <label>
                                                    Data de Nascimento
                                                </label>
                                                <input
                                                    type="date"
                                                    className="form-control"
                                                    placeholder="Data Nascimento"
                                                    name="DT_NASCIMENTO"
                                                    ref={formMethods.register()}
                                                    defaultValue={
                                                        Cliente?.DT_NASCIMENTO
                                                            ? Cliente.DT_NASCIMENTO.slice(
                                                                  0,
                                                                  10
                                                              )
                                                            : ""
                                                    }
                                                />
                                            </div>
                                        </>
                                    )}
                                    <div className="col-lg-12">
                                        <label>Observação</label>
                                        <textarea
                                            name="DS_OBSERVACAO"
                                            className="form-control"
                                            ref={formMethods.register()}
                                            defaultValue={
                                                Cliente?.DS_OBSERVACAO || ""
                                            }
                                        />
                                    </div>
                                </div>
                            </OrSpinner>
                        </Tab>
                        {isPessoaFisica.toString().length <= 11 && (
                            <Tab
                                title={
                                    <>
                                        <span className="nav-icon">
                                            <i className="fas fa-info-circle"></i>
                                        </span>
                                        <span className="nav-text">
                                            Informações Adicionais
                                        </span>
                                    </>
                                }
                                eventKey="InformacoesAdicionais"
                            >
                                <OrSpinner
                                    loading={
                                        lstCanalAtendimentoLoading ||
                                        lstProfissoesLoading ||
                                        lstMotivoCompraLoading
                                    }
                                    spinner="capys"
                                >
                                    <div className="row p-2">
                                        <div className="col-lg-4 mb-3">
                                            <label>Nome do Pai</label>
                                            <input
                                                className="form-control"
                                                name="DS_NOME_PAI"
                                                ref={formMethods.register()}
                                                defaultValue={
                                                    Cliente?.DS_NOME_PAI
                                                }
                                            />
                                        </div>
                                        <div className="col-lg-4 mb-3">
                                            <label>Nome da Mãe</label>
                                            <input
                                                className="form-control"
                                                name="DS_NOME_MAE"
                                                ref={formMethods.register()}
                                                defaultValue={
                                                    Cliente?.DS_NOME_MAE
                                                }
                                            />
                                        </div>
                                        <div className="col-lg-4 mb-3">
                                            <label>Dependentes</label>
                                            <input
                                                className="form-control"
                                                name="NR_DEPENDENTES"
                                                type="number"
                                                ref={formMethods.register()}
                                                defaultValue={
                                                    Cliente?.NR_DEPENDENTES
                                                }
                                            />
                                        </div>

                                        <div className="col-lg-4 mb-3">
                                            <label>Escolaridade</label>
                                            <input
                                                className="form-control"
                                                name="DS_ESCOLARIDADE"
                                                ref={formMethods.register()}
                                                defaultValue={
                                                    Cliente?.DS_ESCOLARIDADE
                                                }
                                            />
                                        </div>
                                        <div className="col-lg-4 mb-3">
                                            <label>Número de Filhos</label>
                                            <input
                                                className="form-control"
                                                name="NR_FILHOS"
                                                type="number"
                                                ref={formMethods.register()}
                                                defaultValue={
                                                    Cliente?.NR_FILHOS
                                                }
                                            />
                                        </div>
                                        <div className="col-lg-4 mb-3">
                                            <label>Imóvel Próprio</label>
                                            <select
                                                className="form-control"
                                                name="DS_IMOVEL_PROPRIO"
                                                ref={formMethods.register()}
                                                defaultValue={
                                                    Cliente?.DS_IMOVEL_PROPRIO
                                                }
                                            >
                                                <option></option>
                                                <option>Não</option>
                                                <option>Sim, quitado</option>
                                                <option>Sim, financiado</option>
                                            </select>
                                        </div>

                                        <div className="col-lg-4 mb-3">
                                            <label>Tempo de Residência</label>
                                            <input
                                                className="form-control"
                                                name="DS_TEMPO_RESIDENCIA"
                                                ref={formMethods.register()}
                                                defaultValue={
                                                    Cliente?.DS_TEMPO_RESIDENCIA
                                                }
                                            />
                                        </div>
                                        <div className="col-lg-4 mb-3">
                                            <label>Veículo Próprio</label>
                                            <select
                                                className="form-control"
                                                name="DS_VEICULO_PROPRIO"
                                                ref={formMethods.register()}
                                                onChange={
                                                    handleVeiculoProprioChange
                                                }
                                                defaultValue={
                                                    Cliente?.DS_VEICULO_PROPRIO
                                                }
                                            >
                                                <option value=""></option>
                                                <option value="Não">Não</option>
                                                <option value="Sim, quitado">
                                                    Sim, quitado
                                                </option>
                                                <option value="Sim, financiado">
                                                    Sim, financiado
                                                </option>
                                            </select>
                                        </div>

                                        {veiculoProprio === "Sim, quitado" ||
                                        veiculoProprio === "Sim, financiado" ? (
                                            <div className="col-lg-4 mb-3">
                                                <label>Tipo de Veículo</label>
                                                <select
                                                    className="form-control"
                                                    name="DS_TIPO_VEICULO"
                                                    ref={formMethods.register()}
                                                    defaultValue={
                                                        Cliente?.DS_TIPO_VEICULO
                                                    }
                                                >
                                                    <option value=""></option>
                                                    <option value="Moto">
                                                        Moto
                                                    </option>
                                                    <option value="Carro">
                                                        Carro
                                                    </option>
                                                </select>
                                            </div>
                                        ) : null}

                                        <div className="col-lg-4 mb-3">
                                            <label>Nacionalidade</label>
                                            <input
                                                className="form-control"
                                                name="DS_NACIONALIDADE"
                                                ref={formMethods.register()}
                                                defaultValue={
                                                    Cliente?.DS_NACIONALIDADE
                                                }
                                            />
                                        </div>

                                        <div className="col-lg-4 mb-3">
                                            <label>Naturalidade</label>
                                            <input
                                                className="form-control"
                                                name="DS_NATURALIDADE"
                                                ref={formMethods.register()}
                                                defaultValue={
                                                    Cliente?.DS_NATURALIDADE
                                                }
                                            />
                                        </div>
                                        <div className="col-lg-4 mb-3">
                                            <label>Saudação</label>
                                            <input
                                                className="form-control"
                                                name="DS_SAUDACAO"
                                                ref={formMethods.register()}
                                                defaultValue={
                                                    Cliente?.DS_SAUDACAO
                                                }
                                            />
                                        </div>
                                        <div className="col-lg-4 mb-3">
                                            <label>Estado Civil</label>
                                            <select
                                                className="form-control"
                                                name="DS_ESTADO_CIVIL"
                                                ref={formMethods.register()}
                                                defaultValue={
                                                    Cliente?.DS_ESTADO_CIVIL
                                                }
                                            >
                                                <option></option>
                                                <option value="Casado(a)">
                                                    Casado(a)
                                                </option>
                                                <option value="Divorciado(a)">
                                                    Divorciado(a)
                                                </option>
                                                <option value="Separado(a)">
                                                    Separado(a)
                                                </option>
                                                <option value="Solteiro(a)">
                                                    Solteiro(a)
                                                </option>
                                                <option value="União Estável">
                                                    União Estável
                                                </option>
                                                <option value="Viúvo(a)">
                                                    Viúvo(a)
                                                </option>
                                            </select>
                                        </div>
                                        <div className="col-lg-4 mb-3">
                                            <label>Profissão</label>
                                            <select
                                                name="ID_PROFISSAO_CONTA"
                                                className="form-control"
                                                ref={formMethods.register()}
                                                defaultValue={
                                                    Cliente?.ID_PROFISSAO_CONTA
                                                }
                                            >
                                                <option></option>
                                                {lstProfissoes?.map(
                                                    (profissao) => (
                                                        <option
                                                            value={
                                                                profissao.ID_PROFISSAO
                                                            }
                                                        >
                                                            {
                                                                profissao.DS_PROFISSAO
                                                            }
                                                        </option>
                                                    )
                                                )}
                                            </select>
                                        </div>
                                        <div className="col-lg-4 mb-3">
                                            <label>Bairro onde Trabalha</label>
                                            <input
                                                className="form-control"
                                                name="DS_BAIRRO_OCUPACAO"
                                                ref={formMethods.register()}
                                                defaultValue={
                                                    Cliente?.DS_BAIRRO_OCUPACAO
                                                }
                                            />
                                        </div>
                                        <div className="col-lg-4 mb-3">
                                            <label>
                                                Empresa em que trabalha
                                            </label>
                                            <input
                                                className="form-control"
                                                name="DS_EMPRESA_EMPREGADORA"
                                                ref={formMethods.register()}
                                                defaultValue={
                                                    Cliente?.DS_EMPRESA_EMPREGADORA
                                                }
                                            />
                                        </div>
                                        <div className="col-lg-4 mb-3">
                                            <label>Motivo Compra</label>
                                            <select
                                                className="form-control"
                                                name="ID_MOTIVO_COMPRA"
                                                ref={formMethods.register()}
                                                defaultValue={
                                                    Cliente?.ID_MOTIVO_COMPRA
                                                }
                                            >
                                                <option></option>
                                                {lstMotivoCompra?.map(
                                                    (perfilTipoConta) => (
                                                        <option
                                                            value={
                                                                perfilTipoConta.ID_MOTIVO_COMPRA
                                                            }
                                                        >
                                                            {
                                                                perfilTipoConta.DS_MOTIVO_COMPRA
                                                            }
                                                        </option>
                                                    )
                                                )}
                                            </select>
                                        </div>
                                        <div className="col-lg-4 mb-3">
                                            <label>Perfil Cliente</label>
                                            <select
                                                className="form-control"
                                                placeholder="Perfil Cliente"
                                                name="ID_TIPO_CLIENTE"
                                                ref={formMethods.register()}
                                                defaultValue={
                                                    Cliente?.tipoConta
                                                        ?.ID_PERFIL_TIPO_CONTA
                                                }
                                            >
                                                <option></option>
                                                {lstPerfilTipoConta?.map(
                                                    (perfilTipoConta) => (
                                                        <option
                                                            value={
                                                                perfilTipoConta.ID_PERFIL_TIPO_CONTA
                                                            }
                                                        >
                                                            {
                                                                perfilTipoConta.DS_PERFIL_TIPO_CONTA
                                                            }
                                                        </option>
                                                    )
                                                )}
                                            </select>
                                        </div>
                                        <div className="col-lg-4 mb-3">
                                            <label>Canal de Atendimento</label>
                                            <select
                                                name="ID_TIPO_CANAL_ATENDIMENTO"
                                                className={`form-control placeholder-dark-50`}
                                                ref={formMethods.register()}
                                                defaultValue={
                                                    Cliente?.ID_TIPO_CANAL_ATENDIMENTO
                                                }
                                            >
                                                <option></option>
                                                {lstCanalAtendimento?.map(
                                                    (canalAtendimento) => (
                                                        <option
                                                            value={
                                                                canalAtendimento.ID_TIPO_CANAL_ATENDIMENTO
                                                            }
                                                        >
                                                            {
                                                                canalAtendimento.DS_TIPO_CANAL_ATENDIMENTO
                                                            }
                                                        </option>
                                                    )
                                                )}
                                            </select>
                                        </div>
                                    </div>
                                </OrSpinner>
                            </Tab>
                        )}
                        <Tab
                            title={
                                <>
                                    <span className="nav-icon">
                                        <i className="fas fa-phone"></i>
                                    </span>
                                    <span className="nav-text">Telefones</span>
                                </>
                            }
                            eventKey="Telefones"
                        >
                            <OrSpinner
                                loading={lstTipoTelefoneLoading}
                                spinner="capys"
                            >
                                <div className="d-flex justify-content-end p-3">
                                    <button
                                        onClick={() =>
                                            setFormVisible(!isFormVisible)
                                        }
                                        aria-controls="collapse-phone-form"
                                        className="btn btn-light-success"
                                        aria-expanded={isFormVisible}
                                        type="button"
                                    >
                                        <FontAwesomeIcon
                                            icon={
                                                isFormVisible
                                                    ? faArrowUp
                                                    : faArrowDown
                                            }
                                        />{" "}
                                        Adicionar Telefone
                                    </button>
                                </div>
                                <Collapse in={isFormVisible}>
                                    <div
                                        id="collapse-phone-form"
                                        className="p-3"
                                    >
                                        <Telefones
                                            lstTipoTelefone={lstTipoTelefone}
                                            handleAddPhone={handleAddPhone}
                                            novoTelefone={novoTelefone}
                                            setNovoTelefone={setNovoTelefone}
                                            customDDI={customDDI}
                                            setCustomDDI={setCustomDDI}
                                        />
                                    </div>
                                </Collapse>
                                <div className="py-2">
                                    <h6>
                                        <FontAwesomeIcon
                                            icon={faPhone}
                                            className="text-primary"
                                        />{" "}
                                        Telefones
                                    </h6>
                                    {listaTelefone.length > 0 ? (
                                        <div className="d-flex flex-column">
                                            {listaTelefone.map(
                                                (phone, index) => (
                                                    <div
                                                        className="d-flex justify-content-between py-5"
                                                        key={index}
                                                    >
                                                        <div className="d-flex flex-column">
                                                            <span className="text-dark-75 font-weight-bolder">
                                                                <span
                                                                    className="mr-2 text-danger text-hover-info"
                                                                    role="button"
                                                                    onClick={() =>
                                                                        handleDeletePhone(
                                                                            index
                                                                        )
                                                                    }
                                                                    aria-label="Excluir telefone"
                                                                >
                                                                    <FontAwesomeIcon
                                                                        icon={
                                                                            faTrash
                                                                        }
                                                                    />
                                                                </span>
                                                                <span className="mr-2">
                                                                    <CopyToClipboard>
                                                                        {`${
                                                                            phone.DDI &&
                                                                            phone.DDI?.includes(
                                                                                "+"
                                                                            )
                                                                                ? phone.DDI
                                                                                : phone.DDI
                                                                                ? "+" +
                                                                                  phone.DDI
                                                                                : ""
                                                                        } ${
                                                                            phone.DDD ??
                                                                            ""
                                                                        }
                                                                        ${
                                                                            phone.NR_TELEFONE
                                                                        }`}
                                                                    </CopyToClipboard>
                                                                </span>
                                                                {`${
                                                                    phone.DDI &&
                                                                    phone.DDI?.includes(
                                                                        "+"
                                                                    )
                                                                        ? phone.DDI
                                                                        : phone.DDI
                                                                        ? "+" +
                                                                          phone.DDI
                                                                        : ""
                                                                } ${
                                                                    phone.DDD ??
                                                                    ""
                                                                }
                                                                        ${
                                                                            phone.NR_TELEFONE
                                                                        }`}
                                                            </span>
                                                            <span>
                                                                {phone.DS_OBSERVACAO
                                                                    ? phone.DS_OBSERVACAO
                                                                    : "Obs: -"}
                                                            </span>
                                                        </div>
                                                        <div className="d-flex flex-column align-items-end">
                                                            <span className="label label-pill label-inline label-success">
                                                                {
                                                                    phone.DS_TIPO_TELEFONE
                                                                }
                                                            </span>
                                                        </div>
                                                    </div>
                                                )
                                            )}
                                        </div>
                                    ) : (
                                        <div className="d-flex justify-content-center py-4">
                                            <span className="text-muted">
                                                Nenhum telefone cadastrado
                                            </span>
                                        </div>
                                    )}
                                </div>
                            </OrSpinner>
                        </Tab>
                        <Tab
                            title={
                                <>
                                    <span className="nav-icon">
                                        <i className="fas fa-dollar-sign"></i>
                                    </span>
                                    <span className="nav-text">
                                        Dados Financeiros
                                    </span>
                                </>
                            }
                            eventKey="DadosFinanceiros"
                        >
                            <OrSpinner
                                loading={lstBancosLoading}
                                spinner="capys"
                            >
                                <div className="row p-2">
                                    <div className="col-lg-4 mb-3">
                                        <label>Banco</label>
                                        <select
                                            name="ID_BANCO"
                                            className="form-control placeholder-dark-50"
                                            ref={formMethods.register()}
                                            defaultValue={Cliente?.ID_BANCO}
                                        >
                                            <option></option>
                                            {lstBancos?.map((banco) => (
                                                <option
                                                    value={banco.ID_BANCO}
                                                    key={banco.ID_BANCO}
                                                >
                                                    {banco.DS_BANCO}
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                    <div className="col-lg-4 mb-3">
                                        <label>Nº Agência</label>
                                        <input
                                            className="form-control"
                                            name="NR_AGENCIA_BANCO"
                                            ref={formMethods.register()}
                                            defaultValue={
                                                Cliente?.NR_AGENCIA_BANCO
                                            }
                                        />
                                    </div>
                                    <div className="col-lg-4 mb-3">
                                        <label>Nº Conta</label>
                                        <input
                                            className="form-control"
                                            name="NR_CONTA_BANCO"
                                            ref={formMethods.register()}
                                            defaultValue={
                                                Cliente?.NR_CONTA_BANCO
                                            }
                                        />
                                    </div>

                                    <div className="col-lg-4 mb-3">
                                        <label>Perfil Financeiro</label>
                                        <select
                                            className="form-control"
                                            placeholder="Perfil Financeiro"
                                            name="ID_PERFIL_FINANCEIRO_CONTA"
                                            ref={formMethods.register()}
                                            defaultValue={
                                                Cliente?.perfilFinanceiro
                                                    ?.ID_PERFIL_FINANCEIRO_CONTA
                                            }
                                        >
                                            <option></option>
                                            {lstPerfilFinanceiro?.map(
                                                (perfilFinanceiro) => (
                                                    <option
                                                        value={
                                                            perfilFinanceiro.ID_PERFIL_FINANCEIRO_CONTA
                                                        }
                                                    >
                                                        {
                                                            perfilFinanceiro.DS_PERFIL_FINANCEIRO_CONTA
                                                        }
                                                    </option>
                                                )
                                            )}
                                        </select>
                                    </div>
                                    <div className="col-lg-4 mb-3">
                                        <label>Renda</label>
                                        <UnForm.Input
                                            {...formMethods}
                                            className="form-control"
                                            name="VL_RENDA"
                                            defaultValue={
                                                Cliente?.VL_RENDA
                                                    ? formatMoneyReais(
                                                          Cliente.VL_RENDA
                                                      )
                                                    : formatMoneyReais(0)
                                            }
                                            registerOptions={{
                                                setValueAs: (v: string) => {
                                                    if (v) {
                                                        return Number(
                                                            MoneyReaisFieldMask.unMask(
                                                                v
                                                            )
                                                        );
                                                    }
                                                    return v;
                                                },
                                            }}
                                            onChange={geradorMascaraFinanceira(
                                                "VL_RENDA"
                                            )}
                                        />
                                    </div>
                                    <div className="col-lg-4 mb-3">
                                        <label>Receber cobrança</label>
                                        <span className="switch switch-outline switch-icon switch-success">
                                            <label>
                                                <input
                                                    type="checkbox"
                                                    defaultChecked={
                                                        Cliente?.FL_RECEBER_COBRANCA ??
                                                        false
                                                    }
                                                    ref={formMethods.register()}
                                                    name="FL_RECEBER_COBRANCA"
                                                />
                                                <span></span>
                                            </label>
                                        </span>
                                    </div>
                                </div>
                            </OrSpinner>
                        </Tab>
                        <Tab
                            title={
                                <>
                                    <span className="nav-icon">
                                        <i className="flaticon2-chat-1"></i>
                                    </span>
                                    <span className="nav-text">Endereços</span>
                                </>
                            }
                            eventKey="enderecos"
                        >
                            <h6 className="pt-6">Endereço de Cobrança</h6>

                            <InformacoesEnderecoCard
                                formIndex={0}
                                ObjectInformacoesEndereco={{
                                    ID_CIDADE_ENDERECO:
                                        Cliente?.ID_CIDADE_COBRANCA,
                                    DS_BAIRRO_ENDERECO:
                                        Cliente?.DS_BAIRRO_COBRANCA,
                                    DS_COMPLEMENTO_ENDERECO:
                                        Cliente?.DS_COMPLEMENTO_COBRANCA,
                                    NR_ENDERECO_ENDERECO:
                                        Cliente?.NR_ENDERECO_COBRANCA,
                                    DS_LOGRADOURO_ENDERECO:
                                        Cliente?.DS_LOGRADOURO_COBRANCA,
                                    NR_CEP_ENDERECO: Cliente?.NR_CEP_COBRANCA,
                                }}
                            />

                            <h6 className="pt-6">Endereço de Entrega</h6>

                            <InformacoesEnderecoCard
                                formIndex={1}
                                ObjectInformacoesEndereco={{
                                    ID_CIDADE_ENDERECO:
                                        Cliente?.ID_CIDADE_ENTREGA,
                                    DS_BAIRRO_ENDERECO:
                                        Cliente?.DS_BAIRRO_ENTREGA,
                                    DS_COMPLEMENTO_ENDERECO:
                                        Cliente?.DS_COMPLEMENTO_ENTREGA,
                                    NR_ENDERECO_ENDERECO:
                                        Cliente?.NR_ENDERECO_ENTREGA,
                                    DS_LOGRADOURO_ENDERECO:
                                        Cliente?.DS_LOGRADOURO_ENTREGA,
                                    NR_CEP_ENDERECO: Cliente?.NR_CEP_ENTREGA,
                                }}
                            />
                        </Tab>
                    </Tabs>

                    <div className="card-footer d-flex justify-content-end pt-2 p-0">
                        <button
                            type="button"
                            className="btn btn-outline-primary font-weight-bold d-flex justify-content-center mr-2"
                            onClick={formMethods.handleSubmit(onSubmitSaveOnly)}
                            disabled={AtualizarClienteLoading}
                        >
                            {AtualizarClienteLoading ? (
                                <>
                                    <Spinner size="sm" /> Salvar Apenas
                                </>
                            ) : (
                                <>
                                    <FontAwesomeIcon
                                        icon={faSave}
                                        size="lg"
                                        className="mr-1"
                                    />
                                    Salvar Apenas
                                </>
                            )}
                        </button>
                        <button
                            type="button"
                            className="btn btn-outline-primary font-weight-bold d-flex justify-content-center"
                            onClick={formMethods.handleSubmit(
                                onSubmitSaveAndClose
                            )}
                            disabled={AtualizarClienteLoading}
                        >
                            {AtualizarClienteLoading ? (
                                <div className="d-flex justify-content-center align-items-center">
                                    <Spinner size="sm" /> Salvar e Fechar
                                </div>
                            ) : (
                                <>
                                    <FontAwesomeIcon
                                        icon={faSave}
                                        size="lg"
                                        className="mr-1"
                                    />
                                    Salvar e Fechar
                                </>
                            )}
                        </button>
                    </div>
                </form>
            </FormProvider>
        </OrSpinner>
    );
}
